import { useState } from 'react'
import { useAuth, useView, userMode } from '@10000/react'
import { Box, PopUpMenu, SupportDialog } from './widgets'
import { Settings } from './admin'
import { useStack } from './layout'

export const UserMenu = ({ open, onClose, mobile }) => {
  const { logout, user } = useAuth()
  const { push } = useStack()
  const { currentSquiz } = useView('tenant')
  const [supportOpen, setSupportOpen] = useState(false)

  const items = [
    ...(!currentSquiz ? [{ text: 'Settings', onClick: () => push(Settings) }] : []),
    { text: 'Help and Support', onClick: () => setSupportOpen(true) },
    { text: 'Log out', onClick: logout },
    ...(user.super
        ? [
            { text: '', onClick: () => { return null } },
            { text: 'Super user mode', onClick: () => userMode('super', '/shivoo/') }
          ]
        : []
    )
  ]

  return (
    <Box className={mobile ? 'mobile-only' : 'desktop-only'} zIndex={1000}>
      <PopUpMenu
        items={items}
        open={open}
        onClose={onClose}
        align="center"
        width={180}
      />
      <SupportDialog open={supportOpen} onClose={() => setSupportOpen(false)} />
    </Box>
  )
}
